import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-xhr-backend";
import { initReactI18next } from "react-i18next";

const fallbackLng = ["en"];

i18n
  .use(LanguageDetector) // detects the current language
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    fallbackLng, // default language
    debug: false,
    interpolation: {
      escapeValue: false, // no need for react. it escapes by default
    },
    detection: {
      // 👇 Custom detection order (you can adjust)
      order: ['querystring', 'localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    resources: {
      en: { translation: require('./locales/en.json') },
      cz: { translation: require('./locales/cz.json') },
      it: { translation: require('./locales/it.json') },
    },
  });

export default i18n;